import React from 'react';
import ServicesSection from '../components/ServicesSection';

const Services: React.FC = () => {
  return (
    <div className="pt-20">
      <ServicesSection />
    </div>
  );
};

export default Services;

